'use strict';

var _ = require('lodash');
var MultiSelectComboboxService = function MultiSelectComboboxService() {
  function getScrollValue(wrapperScroll, wrapperHeight, activeElementTop, activeElementHeight) {
    var scroll = null;
    if (wrapperScroll > activeElementTop) {
      scroll = activeElementTop;
    } else if (wrapperScroll + wrapperHeight < activeElementTop + activeElementHeight) {
      scroll = activeElementTop + activeElementHeight - wrapperHeight;
      if (scroll < 0) {
        scroll = 0;
      }
    }
    return scroll;
  }
  function getPrevElementIndex(activeElementIndex, visibleComboboxElements) {
    var next;
    if (visibleComboboxElements.length) {
      if (activeElementIndex - 1 < 0) {
        next = visibleComboboxElements.length - 1;
      } else {
        next = activeElementIndex - 1;
      }
    } else {
      next = null;
    }
    return next;
  }
  function getNextElementIndex(activeElementIndex, visibleComboboxElements) {
    var next;
    if (visibleComboboxElements.length) {
      if (activeElementIndex + 1 >= visibleComboboxElements.length || !_.isNumber(activeElementIndex)) {
        next = 0;
      } else {
        next = activeElementIndex + 1;
      }
    } else {
      next = null;
    }
    return next;
  }
  function getInputFieldValue(comboboxElements) {
    var selectedItems = [];
    for (var i = 0, length = comboboxElements.length; i < length; i++) {
      var element = comboboxElements[i];
      if (element.selected) {
        selectedItems.push(element.dropdownVisibleValue);
      }
    }
    return selectedItems.join(',');
  }
  function getDataModelValue(comboboxElements) {
    var selectedItems = [];
    for (var i = 0, length = comboboxElements.length; i < length; i++) {
      var element = comboboxElements[i];
      if (element.selected) {
        selectedItems.push(element.originalData.value);
      }
    }
    if (selectedItems.length) {
      return selectedItems;
    } else {
      return null;
    }
  }
  function selectAll(comboboxElements, status) {
    for (var i = 0, length = comboboxElements.length; i < length; i++) {
      comboboxElements[i].selected = status;
    }
  }
  function selectElements(valuesArray, comboboxElements, selectionLimit) {
    var wrongValues = [];
    var selectedValuesObject = {};
    var inputPropertiesObject = {};
    for (var i = 0, length = valuesArray.length; i < length; i++) {
      inputPropertiesObject[valuesArray[i].trim().toLowerCase()] = true;
    }
    for (i = 0, length = comboboxElements.length; i < length; i++) {
      var element = comboboxElements[i];
      var visibleValue = element.dropdownVisibleValue.toString().toLowerCase();
      if (inputPropertiesObject[visibleValue] === true && (Object.keys(selectedValuesObject).length < selectionLimit || selectionLimit === 0)) {
        element.selected = true;
        selectedValuesObject[visibleValue] = true;
      }
    }
    for (i = 0, length = valuesArray.length; i < length; i++) {
      var valuesElement = valuesArray[i].trim();
      if (selectedValuesObject[valuesElement.toLowerCase()] !== true) {
        wrongValues.push(valuesElement);
      }
    }
    return wrongValues;
  }
  function showAllComboboxElements(comboboxElements, selectAllElement, selectionLimit) {
    var visibleComboboxElements = [];
    if (comboboxElements.length && !selectionLimit) {
      visibleComboboxElements.push(selectAllElement);
    }
    visibleComboboxElements = visibleComboboxElements.concat(comboboxElements);
    return visibleComboboxElements;
  }
  function filterComboboxElements(value, comboboxElements, visibleComboboxElements) {
    var activeElementIndex = null;
    _.forEach(comboboxElements, function (element) {
      if (element.dropdownVisibleValue.toString().toLowerCase().indexOf(value.toLowerCase()) === 0) {
        visibleComboboxElements.push(element);
        if (activeElementIndex === null && !element.selected) {
          activeElementIndex = visibleComboboxElements.length - 1;
        }
      }
    });
    if (activeElementIndex === null && visibleComboboxElements.length) {
      activeElementIndex = 0;
    }
    return activeElementIndex;
  }
  function getElementsMaxWidth(dropDownItems) {
    var maxWidth = 0;
    for (var i = 0; i < dropDownItems.length; i++) {
      var elementWidth = dropDownItems[i].clientWidth;
      if (maxWidth < elementWidth) {
        maxWidth = elementWidth;
      }
    }
    return maxWidth;
  }
  return {
    getInputFieldValue: getInputFieldValue,
    getDataModelValue: getDataModelValue,
    selectAll: selectAll,
    getNextElementIndex: getNextElementIndex,
    getPrevElementIndex: getPrevElementIndex,
    getScrollValue: getScrollValue,
    selectElements: selectElements,
    showAllComboboxElements: showAllComboboxElements,
    filterComboboxElements: filterComboboxElements,
    getElementsMaxWidth: getElementsMaxWidth
  };
};
MultiSelectComboboxService.$inject = [];
module.exports = MultiSelectComboboxService;